import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SocketService } from '../shared/SocketService';
import { QuerstionService } from '../questionlist/table-complete/question.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styles: []
})
export class LoginComponent {
  public login = '';
  public password = '';
  public error: string;
  public isSubmitting = false;

  constructor(private socketService: SocketService, private service: QuerstionService, private router: Router, private route: ActivatedRoute) { }

  public async submit() {
    if (!this.login || !this.password) {
      return;
    }
    this.isSubmitting = true;
    this.error = undefined;
    const result = await this.socketService.moderatorLogin(this.login, this.password);
    this.isSubmitting = false;
    if (!result.success) {
      this.error = result.error ?? 'Login fehlgeschlagen';
      return;
    }
    this.service.restoreStatus = 'authenticated';
    // If we got here via the pod's "Fragen verwalten" deep link (/watch/:scoId,
    // see AuthGuard), continue straight into that meeting instead of the picker.
    const scoId = this.route.snapshot.queryParamMap.get('scoId');
    this.router.navigate(scoId ? ['watch', scoId] : ['meetings']);
  }
}

